"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestHolidays = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const HOLIDAY_QUERY = (0, graphql_tag_1.default) `
  query HolidaysQuery($country: String!, $period: PeriodInput!, $lang: Language) {
    holidays(country: $country, period: $period, lang: $lang) {
      date
      name
      type
    }
  }
`;
const requestHolidays = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(HOLIDAY_QUERY, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.holidays;
};
exports.requestHolidays = requestHolidays;
// async function requestHolidays(variables, token) {
//   const response = await fetchRequest({ query: HOLIDAY_QUERY, variables, token })
//   if (!response) return errUtil.noResponse()
//   const { errors, data } = response
//   if (errors) {
//     return errUtil.apiError('holidays', errors)
//   }
//   return data.holidays
// }
exports.default = exports.requestHolidays;
